// fetch client withdrawals
export const FETCH_CLIENT_WITHDRAWALS_REQUESTED =
  'FETCH_CLIENT_WITHDRAWALS_REQUESTED'
export const FETCH_CLIENT_WITHDRAWALS_SUCCESS =
  'FETCH_CLIENT_WITHDRAWALS_SUCCESS'
export const FETCH_CLIENT_WITHDRAWALS_FAIL = 'FETCH_CLIENT_WITHDRAWALS_FAIL'
